import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDhFWbBpd_uF_rjiM1X-mzSDeSxREJzyZ8",
    authDomain: "kingston-921b8.firebaseapp.com",
    projectId: "kingston-921b8",
    storageBucket: "kingston-921b8.firebasestorage.app",
    messagingSenderId: "448845313934",
    appId: "1:448845313934:web:2b2768deb40945d75416df",
    measurementId: "G-HRXR80M33Q"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
